import React from 'react';

import TripDetailsContainer from './trip-details-container';
import { BackNavigationView } from '../../components/back-navigation';
import { getTripRequestBackNavConfig } from '../../components/back-navigation/back-navigation-configs';
import { useBackNavigation } from '../../hooks/use-back-navigation';

const ProvidedTripDetails = () => {
  const { primaryText, handleBack } = useBackNavigation(getTripRequestBackNavConfig);

  return (
    <>
      <BackNavigationView primaryText={primaryText} handleBack={handleBack} dataE2e="ztest-trip-request-back-home" />
      <TripDetailsContainer />
    </>
  );
};

export default ProvidedTripDetails;
